export const _createStripeToken = cardData =>
  new Promise((resolve, reject) => {
    // https://stripe.com/docs/stripe-js/v2#card-createToken
    window.Stripe.setPublishableKey(window.IRISVR_ENV.stripe_key)
    window.Stripe.createToken(cardData, (status, response) => {
      if (response.error) reject(response.error)
      resolve(response)
    })
  })
